import axiosInstance from '../lib/axiosInstance';

export const getBooking = async (bookingId) => {
  return axiosInstance.get(`/bookings/${bookingId}`);
};

export const getCountries = async () => {
  return axiosInstance.get('/countries');
};

export const updateBooking = async ({ bookingId, ...payload }, options = {}) => {
  const headers = {};
  if (options.jwt) headers.Authorization = `Bearer ${options.jwt}`;

  return axiosInstance.put(`/bookings/${bookingId}`, {
    bookingId,
    payload
  }, { headers });
};

export const payBooking = async (bookingId, payLater = true, options = {}) => {
  const headers = {};
  if (options.jwt) headers.Authorization = `Bearer ${options.jwt}`;

  return axiosInstance.put(`/bookings/${bookingId}/pay`, { payLater }, { headers });
};

